import { useSelector } from "react-redux"

const getContainsIgnoredAttributes = (technologyAttributes) => {
    const cinemaData = useSelector((state) => state.toJS().cinemaData)
    const {front} = cinemaData 
    const {ignore_attributes_for_performance_filter} = front

    return _.find(technologyAttributes, attribute => {
        return _.contains(ignore_attributes_for_performance_filter, attribute.id) 
    })
}

export default getContainsIgnoredAttributes